// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2XYxe","info":"Note_info__sOGsf","note":"Note_note__2SdI2","actions":"Note_actions__2yeMo"};